<template lang="pug">
  div
    v-dialog(
      no-click-animation
      persistent
      max-width="480"
      @keydown="onTyping"
      v-model="showDialog"
    )
      v-card
        v-card-title(:class="colorConfirm")
          v-btn(v-if="isBack" icon dark @click="close($event)" :disabled="loadingOkBtn")
            v-icon mdi-keyboard-backspace

          span.text-h6.white--text {{ title ? title : $t('common.confirm') }}
          v-spacer
          portal-target(name="header-dialog-action")
          v-btn(icon dark @click="$emit('on-close', $event)" :disabled="loadingOkBtn")
            v-icon mdi-close

        v-card-text.relative-card.pa-0
          v-row(no-gutters)
            slot(name="body-prepend")
          v-row.ma-5.display-msg(justify="center")
            span(v-if="messages" v-for="msg in messages") {{ msg }}
            //- span(v-if="isDeleteMaster" ) {{$t('message.never_use_in_future')}}
            //- span(v-if="isDeleteMaster" ) {{$t('message.delete_master_being_used')}}
          v-row(justify="center" no-gutters)
            slot(name="body-append")
        v-card-actions(v-if="!hideActions" :class="cancelText ? '' : 'confirm'")
          v-btn.relative-btn(
            v-if="cancelText"
            width="50%"
            color="rough_black"
            @click="cancel()"
          )
            span {{ cancelText }}
          v-btn.relative-btn(
            v-if="!delText"
            ref="okBtnRef"
            width="50%"
            dark
            :color="colorConfirm"
            @click="ok()"
            :loading="loadingOkBtn"
          )
            span.white--text {{ okText }}
          v-btn.relative-btn.primary(
            v-if="!okText"
            width="50%"
            dark
            color="red"
            :loading="loadingOkBtn"
            @click="ok()"
          )
            span.white--text {{ delText }}
</template>

<script>
import { defineComponent, toRefs, watch, ref } from 'vue'

const JConfirmDialog = defineComponent({
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    messages: {
      type: Array,
      default: () => []
    },
    okText: {
      type: String,
      required: false
    },
    delText: {
      type: String,
      required: false
    },
    cancelText: {
      type: String,
      required: false
    },
    isBack: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      default: '',
      required: false
    },
    colorConfirm: {
      type: String,
      default: 'primary'
    },
    title: {
      type: String,
      default: null,
      required: false
    },
    isDeleteMaster: {
      type: Boolean,
      default: false,
      required: false
    },
    loadingOkBtn: {
      type: Boolean,
      default: false,
      required: false
    },
    hideActions: {
      type: Boolean,
      default: false,
      required: false
    },
    keepOpenOnOk: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  setup(props, { emit }) {
    const { showDialog } = toRefs(props)
    const okBtnRef = ref(null)
    const focusOkButton = () => {
      if (okBtnRef.value) okBtnRef.value.$el?.focus()
    }

    const cancel = () => {
      emit('on-cancel')
    }

    const firstClickOk = ref(true)
    const ok = () => {
      if (props.keepOpenOnOk) {
        emit('on-ok')
        return
      }
      if (!firstClickOk.value) return
      firstClickOk.value = false
      emit('on-ok')
    }

    const close = (event) => {
      emit('on-close', event)
    }

    const onTyping = (event) => {
      if (event.keyCode === 27) {
        // Press ESC
        event.stopPropagation()
        if (!props.loadingOkBtn) close(event)
      }
      if (event.keyCode === 13) {
        event.stopPropagation()
        if (props.loadingOkBtn) return
        const activeElement = document.activeElement
        if (
          activeElement &&
          (activeElement.tagName === 'BUTTON' ||
            activeElement.getAttribute('role') === 'button' ||
            activeElement.tagName === 'INPUT' ||
            activeElement.tagName === 'TEXTAREA')
        ) {
          return
        }
        event.preventDefault()
        ok()
      }
    }

    watch(
      () => showDialog.value,
      (newVal) => {
        if (newVal) firstClickOk.value = true
      }
    )

    return {
      okBtnRef,
      focusOkButton,
      cancel,
      ok,
      onTyping
    }
  }
})
export default JConfirmDialog
</script>
<style lang="sass" scoped>
@import '@/style/css/common.sass'
.v-dialog__content
  z-index: 100001 !important
.v-dialog > *
  width: auto
  @include relative-fontsize-2

.relative-btn
  @include relative-fontsize-2

.v-card
  ::v-deep .v-card__title
    position: sticky
    top: 0
    z-index: 999

  ::v-deep .v-card__actions
    position: sticky
    background-color: white
    bottom: 0
    z-index: 999

  span
    @include relative-fontsize-2

.display-msg
  display: inline-grid
  white-space: pre-wrap

.message
  font-weight: bold
  font-size: 15px
.confirm
  justify-content: center
</style>
